import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IUser } from 'app/shared/model/user.model';
import { getUsers } from 'app/shared/reducers/user-management';
import { INewsFeed } from 'app/shared/model/news-feed.model';
import { getEntity, updateEntity, createEntity, reset } from './news-feed.reducer';

export const NewsFeedUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const users = useAppSelector(state => state.userManagement.users);
  const newsFeedEntity = useAppSelector(state => state.newsFeed.entity);
  const loading = useAppSelector(state => state.newsFeed.loading);
  const updating = useAppSelector(state => state.newsFeed.updating);
  const updateSuccess = useAppSelector(state => state.newsFeed.updateSuccess);

  const handleClose = () => {
    navigate('/news-feed' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getUsers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.createdDate = convertDateTimeToServer(values.createdDate);
    values.modifiedDate = convertDateTimeToServer(values.modifiedDate);

    const entity = {
      ...newsFeedEntity,
      ...values,
      user: users.find(it => it.id.toString() === values.user.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          createdDate: displayDefaultDateTime(),
          modifiedDate: displayDefaultDateTime(),
        }
      : {
          ...newsFeedEntity,
          createdDate: convertDateTimeFromServer(newsFeedEntity.createdDate),
          modifiedDate: convertDateTimeFromServer(newsFeedEntity.modifiedDate),
          user: newsFeedEntity?.user?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fivePlusApp.newsFeed.home.createOrEditLabel" data-cy="NewsFeedCreateUpdateHeading">
            <Translate contentKey="fivePlusApp.newsFeed.home.createOrEditLabel">Create or edit a NewsFeed</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="news-feed-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('fivePlusApp.newsFeed.description')}
                id="news-feed-description"
                name="description"
                data-cy="description"
                type="textarea"
              />
              <ValidatedField
                label={translate('fivePlusApp.newsFeed.imageName')}
                id="news-feed-imageName"
                name="imageName"
                data-cy="imageName"
                type="text"
              />
              <ValidatedField label={translate('fivePlusApp.newsFeed.link')} id="news-feed-link" name="link" data-cy="link" type="text" />
              <ValidatedField
                label={translate('fivePlusApp.newsFeed.createdDate')}
                id="news-feed-createdDate"
                name="createdDate"
                data-cy="createdDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('fivePlusApp.newsFeed.modifiedDate')}
                id="news-feed-modifiedDate"
                name="modifiedDate"
                data-cy="modifiedDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('fivePlusApp.newsFeed.videoFile')}
                id="news-feed-videoFile"
                name="videoFile"
                data-cy="videoFile"
                type="text"
              />
              <ValidatedField id="news-feed-user" name="user" data-cy="user" label={translate('fivePlusApp.newsFeed.user')} type="select">
                <option value="" key="0" />
                {users
                  ? users.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/news-feed" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default NewsFeedUpdate;
